<template>
  <v-checkbox-btn
    style="align-items: start"
    v-model="toggle"
    @click="togglePinKey('1', myKey, 'General', item.value)"
    class="pe-2"></v-checkbox-btn>
</template>
<script setup>
import { ref, defineProps, onMounted, watch } from 'vue';
import { deluge, deluge_sock } from '@/stores/deluge.js';
const props = defineProps(['myKey', 'item']);
const toggle = ref(false);
onMounted(() => {
  toggle.value = deluge?.pinned_svars?.['1']?.['General']?.[props.myKey]?.auto;
});
watch(
  () => deluge.pinned_svars,
  (newVal, oldVal) => {
    toggle.value = newVal['1']['General'][props.myKey]?.auto;
  }
);
function togglePinKey(frame, svar, preset, val) {
  let pinned_items = JSON.parse(JSON.stringify(deluge.pinned_svars));
  if (svar in pinned_items[frame][preset]) {
    pinned_items[frame][preset][svar].auto =
      !pinned_items[frame][preset][svar].auto;
  }
  if (window.self !== window.top) {
    parent.postMessage(
      {
        deluge_cmd: {
          cmd: 'STORE',
          key: 'pinned_svars',
          publish: true,
          persist: true,
          keys: [],
          val: pinned_items,
        },
      },
      '*'
    );
    if (deluge?.pinned_svars?.['1']?.['General']?.[svar]?.auto) {
      parent.postMessage({
        deluge_core_cmd: JSON.stringify({
          cmd: 'set_scene_data',
          data: { name: svar, data: val },
        }),
      });
    }
  } else {
    deluge_sock.value.send(
      new Blob([
        JSON.stringify({
          cmd: 'STORE',
          key: 'pinned_svars',
          publish: true,
          persist: true,
          keys: [],
          val: pinned_items,
        }),
      ])
    );
    if (pinned_items[frame][preset][svar].auto) {
      deluge_sock.value.send(
        JSON.stringify({
          cmd: 'set_scene_data',
          data: { name: svar, data: val },
        })
      );
    }
  }
}
</script>
